import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { colorNameToTranslationLabel } from '@app/akita/api/products/models/product.model';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { PriceModel } from '@app/shared/models/api/price.model';
import { Observable } from 'rxjs';
import { AmountPipe } from '../../../shared/pipes/amount.pipe';
import { AsyncPipe } from '@angular/common';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { TranslocoModule } from '@ngneat/transloco';
import { InstallmentAmountPipe } from '@app/shared/pipes/installment-amount.pipe';

@Component({
  selector: 'app-product-model-item',
  templateUrl: './product-model-item.template.html',
  styleUrls: ['./product-model-item.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoModule,
    RouterLink,
    PictureComponent,
    AsyncPipe,
    AmountPipe,
    InstallmentAmountPipe,
  ],
})
export class ProductModelItemComponent implements OnChanges {
  @Input() public product?: string | null;
  @Input() public productTitle?: string | null;
  @Input() public category?: string | null;
  @Input() public imageUrl?: string | null;
  @Input() public id?: number | string | null;
  @Input() public price?: PriceModel | null;
  @Input() public collectionItem?: boolean | null = false;
  @Input() public storage?: string | null;
  @Input() public color?: string | null;

  public biggerThan$: Observable<ScreenSizeInfoState>;

  public parsedModel: string;

  public urlFragments: string | string[];
  public queryParameters: Params;

  public readonly lessThan$: Observable<ScreenSizeInfoState>;

  constructor(
    private readonly akitaScreenQuery: AkitaScreenQuery,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    this.parsedModel = this.parseModelField(this.product || '');

    this.biggerThan$ = this.akitaScreenQuery.selectBiggerThan();

    this.queryParameters = {
      ...this.akitaRouterQuery.queryParamsToKeep,
    };
    this.urlFragments = '';
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.product || changes?.id) {
      this.parsedModel = this.parseModelField(this.product || '');

      this.urlFragments = this.getProductFragment();
      this.queryParameters = {
        ...this.akitaRouterQuery.queryParamsToKeep,
      };
      this.changeDetector.markForCheck();
    }
  }

  public parseModelField(field: string | null): string {
    if (field) {
      const model = field.replace(/_/g, ' ');
      return model;
    }
    return field || '';
  }

  public getTransLabel(color?: string | null): string {
    if (color) {
      return colorNameToTranslationLabel(color);
    }
    return '';
  }

  public getImageUrl(ext: string | null | undefined): string {
    return ext ? `/assets/iphones/${ext.toLowerCase().replace(/ /g, '_')}.webp` : '';
  }

  public getSearchUrlFragment(): Array<string> | string {
    return this.akitaRouterQuery.getPhoneSearchFragment();
  }

  public getProductFragment(): Array<string> {
    return this.akitaRouterQuery.getProductUrlFragment(
      `${this.id}` || '',
      this.productTitle || ''
    );
  }
}
